import { styled } from 'styled-components';
import { SelectableButton } from 'app/components/selectable-button';

export const ClassificationButtonsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)}px;
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing(3)}px;
`;

export const StyledClassificationButton = styled(SelectableButton)<{ $textColor?: string; $backgroundColor?: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};
`;
